import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

const Administrators = () => {
  const { selectedOrganisation } = useAuth();

  return (
    <Box>
      <Typography variant="h4" gutterBottom fontWeight={600}>
        Administrators
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Administrators for {selectedOrganisation?.name || 'Organisation'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Coming soon...
        </Typography>
      </Paper>
    </Box>
  );
};

export default Administrators;